// @flow
import { authenticatedFetch } from '../../api/request';

const getUser = async () => {
    return await authenticatedFetch('/v5/users');
};

export default getUser;
